import { Typography } from '@automata/ui';
import Box from '@mui/material/Box';
import { Position } from 'reactflow';

import {
  SOURCE_HANDLE_IDENTIFIER,
  TARGET_HANDLE_IDENTIFIER,
} from '../../../../constants';
import { serializeLabwareHandlePairId } from '../../../../utils';
import Handle from '../../Handle';

export type Props = {
  hasDeadEnd: boolean;
  handlePairId: string;
};

const EmptyLabwareSection = ({ hasDeadEnd, handlePairId }: Props) => {
  return (
    <Box position="relative" sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
      <Typography variant="body2">Add</Typography>
      <Typography variant="body2">Labware</Typography>
      <Handle
        id={serializeLabwareHandlePairId(
          TARGET_HANDLE_IDENTIFIER,
          handlePairId
        )}
        type="source"
        position={Position.Top}
        style={{ top: -25 }}
      />
      {hasDeadEnd ? null : (
        <Handle
          id={serializeLabwareHandlePairId(
            SOURCE_HANDLE_IDENTIFIER,
            handlePairId
          )}
          type="source"
          position={Position.Bottom}
          style={{ bottom: -25 }}
        />
      )}
    </Box>
  );
};

export default EmptyLabwareSection;
